import TiclickTable from '@src/design-system/molecules/ticlick-table';
import { useBulkRemindersTable } from './use-bulk-reminders-table';

export function BulkRemindersTable() {
  const { table, actionsTable } = useBulkRemindersTable();

  return (
    <TiclickTable
      table={table}
      props={{ searchInputProps: { queryKey: 'name' } }}
      actions={actionsTable}
    />
  );
}
